import React, { PureComponent } from 'react';
import { Form, FormGroup } from '../../../../../../../components/Forms/Forms';
import { Input, Select } from '../../../../../../../components/Forms/fields';
import enums from '../../../../../../../constants/enums';

class PaymentFiltersView extends PureComponent {
  constructor(props){
    super(props);
  }
  render() {
    let {
      onFilterChange,
      filtersFormState,
      trade,
    } = this.props;

    let giftcards = enums.giftcards;
    if (!giftcards.find(gc => gc.value === trade.type)) {
      giftcards = [
        ...giftcards,
        {
          value: trade.type,
        },
      ];
    }

    return (
      <div className="admin-payment-filters-view">
        <Form state={filtersFormState} onSubmit={()=>{}} onChange={onFilterChange}>
          <FormGroup>
            <label>Type:</label>
            <Select name="type" options={giftcards} selectLabel="-" emptyOption/>
          </FormGroup>
          <FormGroup>
            <label>Sort By:</label>
            <Select name="sort" options={enums.paymentSortOptions} />
          </FormGroup>
        </Form>
      </div>
    );
  }
}

export default PaymentFiltersView;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeDetails/SellPaymentsPanel/SellPaymentsModal/SellPaymentFilters/SellPaymentFilters.view.js